let credentialHandler = () => {};

/**
 * Points the Google Identity callback at the button that is currently mounted.
 */
export function setGsiCredentialHandler(next) {
  credentialHandler = typeof next === 'function' ? next : () => {};
}

/**
 * Delivers a Google ID token to the active sign-in button.
 */
export function dispatchGsiCredential(credential) {
  credentialHandler(credential);
}
